import React from "react";
import { useMessageSource } from "react-message-source";
import { Benefit } from "../benefits";
import { Product } from "../../../../context/product-context/product";

const classNameBase = "scd-product-selection-benefits";

export default function LoyaltyProgrammes({
  selectedProduct,
}: {
  selectedProduct: Product;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  const hasMilesAndMore = selectedProduct?.hasFeature("MILES_AND_MORE");

  const hasPartnerPlusBenefits = selectedProduct?.hasFeature(
    "PARTNER_PLUS_BENEFIT",
  );

  const hasMembershipRewards =
    selectedProduct?.hasFeature("MEMBERSHIP_REWARDS");
  const hasTurnoverBonus =
    selectedProduct?.hasFeature("TURNOVER_BONUS_HIGH") ||
    selectedProduct?.hasFeature("TURNOVER_BONUS_LOW");

  // noinspection OverlyComplexBooleanExpressionJS
  const hasLoyaltyProgramme =
    hasMilesAndMore ||
    hasPartnerPlusBenefits ||
    hasMembershipRewards ||
    hasTurnoverBonus;

  if (!hasLoyaltyProgramme) {
    return null;
  }

  return (
    <>
      <Benefit
        className={`${classNameBase}-item`}
        iconTick
        label={getMessage(
          `ProductBenefits.loyaltyPrograms-${selectedProduct?.productRef}.label`,
        )}
      />
      <ul className={`${classNameBase}-sublist`}>
        {hasPartnerPlusBenefits && (
          <Benefit
            className={`${classNameBase}-sublist-item`}
            label={getMessage(
              "ProductBenefits.loyaltyPrograms.partner-plus-benefits.label",
            )}
          />
        )}
        {hasMilesAndMore && (
          <Benefit
            className={`${classNameBase}-sublist-item`}
            label={getMessage(
              "ProductBenefits.loyaltyPrograms.miles-and-more.label",
            )}
          />
        )}
        {hasMembershipRewards && (
          <Benefit
            className={`${classNameBase}-sublist-item`}
            label={getMessage(
              `ProductBenefits.loyaltyPrograms.amex-reward-${selectedProduct?.productRef}.label`,
            )}
          />
        )}
      </ul>
    </>
  );
}
